import {
  SET_NONVIOLATION_LOADING,
  LOAD_NONVIOLATION_DATA,
  APPEND_NONVIOLATION_NODES,
  RESET_NONVIOLATION_NODES
} from '../../config/actions';

const defaultBucket = {
  items: [],
  nextCursor: null,
  hasNextPage: false,
};

const initialState = {
  loading: false,
  metadata: {},
  passes: { ...defaultBucket },
  incomplete: { ...defaultBucket },
};

export default function nonViolationDetailsReducer(state = initialState, action) {
  switch (action.type) {

    case RESET_NONVIOLATION_NODES:
      return {
        ...state,
        passes: { ...defaultBucket },
        incomplete: { ...defaultBucket },
      };

    case SET_NONVIOLATION_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case LOAD_NONVIOLATION_DATA: {
      debugger;
      const { resultType, items, nextCursor, hasNextPage } = action.payload;

      return {
        ...state,
        metadata: {
          sessionId: action.payload.latestSessionId,
          issueLabel: action.payload.help,
          whyItMatters: action.payload.whyItMatters,
          howToFix: action.payload.howToFix,
          relevantGuidelines: action.payload.relevantGuidelines,
          impact: action.payload.impact,
          totalNodes: action.payload.totalNodes,
          diff: action.payload.diff,
          ruleId: action.payload.ruleId,
          wcagSections: ((action.payload.wcagSections || [])
            .map((wcag) => wcag.section)
            .join(', ')),
        },
        [resultType]: {
          items: items || [],
          nextCursor,
          hasNextPage,
        },
      };
    }

    case APPEND_NONVIOLATION_NODES: {
      const { resultType, items, nextCursor, hasNextPage } = action.payload;

      return {
        ...state,
        [resultType]: {
          items: [...state[resultType].items, ...(items || [])],
          nextCursor,
          hasNextPage,
        },
      };
    }

    default:
      return state;
  }
}